/**
 * Checks if input string matches Classifieds key
 * @param {String} source
 * @return {Boolean}
 */
export const getIsClassifiedsCar = (source) => source === 'TSP';
